<template>
  <div class="notes">
    <p class="notes__title mb-0">{{ $t('rev.notes.note_one') }}</p>
    <div v-if="!isEditMode" class="notes__view-mode">
      <div v-if="notesAreEmpty" class="notes__empty-state-wrapper">
        <v-img
          alt="empty_state"
          max-height="156"
          max-width="156"
          class="mx-auto mb-4"
          :src="emptyStateImage"
        >
        </v-img>
        <p class="body-1">
          {{ $t('rev.notes.there_isnt_any_note_yet') }}
        </p>
      </div>
      <div v-else class="notes__view-mode-card-wrapper">
        <div data-private class="notes__view-mode-card">
          <div v-linkify class="notes__view-mode-note">
            {{ $sanitize(notes, { allowedTags: ['a'] }) }}
          </div>
        </div>
      </div>
    </div>
    <div v-else class="notes__edit-mode">
      <v-textarea
        v-model="notes"
        data-private
        data-testid="RevView-textarea-notes"
        auto-grow
        no-resize
        solo
        flat
        dense
        background-color="grey lighten-5"
        name="notes__text-area"
        :placeholder="$t('rev.notes.enter_your_notes_here')"
        :maxlength="maxlength"
        :counter="maxlength"
        rows="20"
        :col="33"
      >
      </v-textarea>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'

import emptyStateImage from '@/assets/images/icons/notes-empty-state.svg'

export default {
  props: {
    isEditMode: {
      type: Boolean,
      required: false,
      default: false,
    },
    revNotes: {
      type: String,
      required: false,
      default: '',
    },
    modelName: {
      type: String,
      required: true,
    },
  },
  data: function() {
    return {
      emptyStateImage,
      maxlength: 5000,
    }
  },
  computed: {
    notesAreEmpty: function() {
      return _.isEmpty(this.revNotes)
    },
    notes: {
      get: function() {
        return this.revNotes || ''
      },
      set: function(notes) {
        this.$emit('notesChanged', notes)
      },
    },
  },
}
</script>
<style lang="scss" scoped>
.notes {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  &__view-mode {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    &-card-wrapper {
      height: 100%;
    }
    &-card {
      border-radius: 4px;
      margin: 16px;
    }
    &-note {
      font-weight: normal;
      font-size: 14px;
      color: $color-blue-grey-darken2;
      word-break: break-word;
      white-space: pre-wrap;
    }
  }

  &__title {
    color: $color-blue-grey-darken3;
    padding: 12px;
    border-bottom: 1px solid $color-blue-grey-lighten2;
    font-size: 14px;
    font-weight: 500;
  }

  &__empty-state {
    &-wrapper {
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    &-title {
      font-size: 16px;
      color: $color-blue-grey-darken3;
    }
  }
  &__edit-mode {
    margin: 8px;
    border-radius: 4px;
  }
}
</style>
